import { clearUserScopedCaches } from 'src/mtska-frontend-app-component/utils/cacheTtl';

let logoutInFlight = null;

export const performLogout = async ({ appConfiguration, logout, doAction, skipAction = false } = {}) => {
    if (logoutInFlight) return logoutInFlight;

    logoutInFlight = (async () => {
        try {
            if (!skipAction) {
            await doAction?.({
                    action: 'logout',
                    model: 'auth/user',
                    data: { clean: true },
                });
            }
        } catch (error) {
            // Still proceed with client-side logout/redirect even if the backend call fails.
            // eslint-disable-next-line no-console
            console.warn('Backend logout failed; proceeding with client logout.', error);
        } finally {
            try {
                sessionStorage.clear();
            } catch (e) { }

            try {
                localStorage.removeItem('token');
            } catch (e) { }

            try {
                clearUserScopedCaches();
            } catch (e) { }

            try {
                const returnTo =
                    process.env.REACT_APP_AUTH0_DEFAULT_LOGGEDOUT_URI ||
                    appConfiguration?.auth0?.DEFAULT_LOGGEDOUT_URI;

                const hasProviderLogout = typeof logout === 'function';

                if (hasProviderLogout) {
                    await logout({
                        logoutParams: {
                            returnTo,
                        },
                    });
                } else if (typeof window !== 'undefined') {
                    // If we're not running under Auth0 (e.g. Azure/Cognito), clearing the token alone
                    // won't trigger React Router loaders; force a navigation to the public entry route.
                    window.location.assign(returnTo || '/');
                }
            } finally {
                logoutInFlight = null;
            }
        }
    })();

    return logoutInFlight;
};

